import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import { createApolloProvider } from '@vue/apollo-option'
import { ApolloClients } from '@vue/apollo-composable'
import { onError } from '@apollo/client/link/error'
import { ApolloLink } from '@apollo/client/link/core'
import { handlers } from 'boot/errorHandler'
import { removeTypenameFromVariables } from '@apollo/client/link/remove-typename'
// import axios from 'axios'
// import { DefaultApolloClient } from '@vue/apollo-composable'

const errorLink = onError(err => handlers.graphql(err))

const typenameLink = removeTypenameFromVariables()

// HTTP connection to the API
const httpLink = ApolloLink.from([
  typenameLink,
  errorLink,
  createHttpLink({
    uri: '/__publicPath__/graphql',
    fetch: (...args) => fetch(...args)
  })
])

const httpLinkProtected = ApolloLink.from([
  typenameLink,
  errorLink,
  createHttpLink({
    uri: '/__publicPath__/graphql-protected',
    fetch: (...args) => fetch(...args)
  })
])

const httpLinkEgs = ApolloLink.from([
  typenameLink,
  errorLink,
  createHttpLink({
    uri: '/__publicPath__/graphql-egs',
    fetch: (...args) => fetch(...args)
  })
])

// Cache implementation
const cache = new InMemoryCache({
  typePolicies: {
    Product: {
      keyFields: ['productId']
    },
    ProductSearchState: {
      keyFields: ['issueId']
    }
    /* ProductSearchResult: {
      keyFields: ['productId']
    } */
  }
})

const protectedCache = new InMemoryCache()

const egsCache = new InMemoryCache()

// Create the apollo client
const defaultClient = new ApolloClient({
  link: httpLink,
  cache
})

const protectedClient = new ApolloClient({
  name: 'protected',
  link: httpLinkProtected,
  cache: protectedCache
})

const egsClient = new ApolloClient({
  name: 'egs',
  link: httpLinkEgs,
  cache: egsCache
})

const apolloProvider = createApolloProvider({
  defaultClient,
  clients: {
    protected: protectedClient,
    egs: egsClient
  }
})

export default ({ app }) => {
  app.use(apolloProvider)
  app.provide(ApolloClients, {
    default: defaultClient,
    egs: egsClient,
    protected: protectedClient
  })
}

export { defaultClient as apolloClient, protectedClient }
